/**
 * Which commercial edition this bundle is.
 *
 *   consumer — the free App Store app: 30-day trial, then the IAP paywall.
 *   vpp      — the €99 bundle bought in volume through Apple Business /
 *              School Manager and assigned to iPads by MDM. Unlocked from
 *              first launch: no trial, no paywall, no IAP.
 *
 * Single source of truth for `VITE_APP_EDITION` — branch on `isVppEdition`,
 * never read the env var elsewhere. Same doctrine as `lib/platform.ts`.
 *
 * This is a *build* flavor, not a runtime switch: the two editions ship as
 * separate App Store records (`com.digola.lingotalk` and
 * `com.digola.lingotalk.vpp`, iOS targets `App` and `App VPP`). The value here
 * only decides what the client asks for — the server is still authoritative
 * for entitlement, and it stamps the channel onto the patient at bootstrap.
 */

export type AppEdition = 'consumer' | 'vpp'

export const edition: AppEdition =
  import.meta.env.VITE_APP_EDITION === 'vpp' ? 'vpp' : 'consumer'

export const isVppEdition = edition === 'vpp'

/**
 * Baked into the VPP bundle and replayed on bootstrap so a consumer build
 * can't trivially claim the unlocked channel. Obfuscation-grade by design —
 * anyone who can read the bundle can read this. Empty on consumer builds.
 */
export const vppEditionKey: string =
  (isVppEdition && import.meta.env.VITE_VPP_EDITION_KEY) || ''

/**
 * Sentinel string baked into every bundle so the release script can tell a
 * VPP build from a production one *after* `cap sync`. Both point at the same
 * API host, so the host check in `scripts/release/channels.mjs` cannot
 * distinguish them — see the comment there. Exported (and referenced from
 * App.vue) purely so tree-shaking can't drop it.
 */
export const EDITION_SENTINEL = `lingotalk-edition:${edition}`
